/**
 * 首页运营接口
 * 
 * @author 张子超
 * @since 2018-04-04
 */
import common from './common'
import store from './store'

var ApiList = {};

//API 接口



/**
 * 获取首页大图列表
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getBannerList = function(okCb, failCb){
    var p = {
    }
    common.ApiWithCache('/customer/api/homepage/bannerList.json', p, okCb, failCb)
}

/**
 * 获取首页图标列表
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getHotIconList = function(okCb, failCb){
    var p = {
    }
    common.ApiWithCache('/customer/api/homepage/hotIconList.json', p, okCb, failCb)
}

/**
 * 获取推荐商品列表
 * @param {*} lastId
 * @param {*} limit
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getRecommendProductList = function( okCb, failCb){
    var p = {
    }

    if (store.loginedUser.easyUser) {
        common.ApiWithCache('/customer/api/easyProduct/recommendList.json', p, okCb, failCb)
    } else {
        common.ApiWithCache('/customer/api/product/recommendList.json', p, okCb, failCb)
    }
}

/**
 * 获取热门商品列表
 * @param {*} lastId
 * @param {*} limit
 * @param {*} okCb 
 * @param {*} failCb 
 */
ApiList.getHotProductList = function(lastId, limit,okCb, failCb){
    var p = {
        lastId, limit
    }

    if (store.loginedUser.easyUser) {
        common.ApiWithCache('/customer/api/easyProduct/hotList.json', p, okCb, failCb)
    } else {
        common.ApiWithCache('/customer/api/product/hotList.json', p, okCb, failCb)
    }
}

ApiList.getShowRedDot = function(okCb, failCb){
    var p = {}
    common.Api('/customer/api/lottery/presentShred/showRedDot.json', p, okCb, failCb)
}


export default ApiList;


// WEBPACK FOOTER //
// ./src/api/homepage-api.js